export const BOTTOM_MARGIN = 24;
export const PERCENTAGE_MULTIPLIER = 100;
export const PERCENTAGE_SCALE = 100;
export const MINIMIZED_PLAYER_HEIGHT = 180;

export const ICON_SIZE = 24;

export const VELOCITY_OPTIONS = [
	{ label: '0,25', value: 0.25 },
	{ label: '0,5', value: 0.5 },
	{ label: 'Normal', value: 1 },
	{ label: '1,25', value: 1.25 },
	{ label: '1,5', value: 1.5 },
	{ label: '1,75', value: 1.75 },
	{ label: '2', value: 2 }
];

export const SPINNER_SIZES = {
	draggable: 'default',
	static: 'large'
} as const;
